export default "__VITE_ASSET__dAi7HLMz__"